import type { ReactNode } from "react";
import { cn } from "../../utils/format";

interface SectionHeadingProps {
  eyebrow?: string;
  title: string;
  /** Trecho final do título exibido em amarelo. */
  highlight?: string;
  description?: ReactNode;
  align?: "left" | "center";
  tone?: "dark" | "cream";
  as?: "h1" | "h2";
  id?: string;
  className?: string;
}

export const SectionHeading = ({
  eyebrow,
  title,
  highlight,
  description,
  align = "left",
  tone = "dark",
  as: Tag = "h2",
  id,
  className,
}: SectionHeadingProps) => (
  <div className={cn(align === "center" && "mx-auto text-center", "max-w-2xl", className)}>
    {eyebrow && (
      <p
        className={cn(
          "mb-3 text-xs font-semibold uppercase tracking-[0.3em]",
          tone === "dark" ? "text-primary" : "text-night/70",
        )}
      >
        {eyebrow}
      </p>
    )}
    <Tag
      id={id}
      className={cn(
        "font-display text-5xl leading-[0.95] tracking-wide sm:text-6xl",
        tone === "dark" ? "text-white" : "text-night",
      )}
    >
      {title}
      {highlight && (
        <>
          {" "}
          <span className={tone === "dark" ? "text-primary" : "text-primary-deep"}>{highlight}</span>
        </>
      )}
    </Tag>
    <span
      aria-hidden="true"
      className={cn("mt-4 block h-1 w-14 rounded-full bg-primary", align === "center" && "mx-auto")}
    />
    {description && (
      <p className={cn("mt-5 text-sm leading-relaxed sm:text-base", tone === "dark" ? "text-muted" : "text-night/70")}>
        {description}
      </p>
    )}
  </div>
);
